import { useCallback } from "react";

/**
 * Centralized full-screen node editor open/close state (managed by FlowBuilder).
 */
export function useFlowNodeEdit(nodeId, data) {
  const isEditing = data?.__editingNodeId === nodeId;

  const openEditor = useCallback(
    (e) => {
      e?.stopPropagation?.();
      data?.openNodeEditor?.(nodeId);
    },
    [nodeId, data?.openNodeEditor]
  );

  const closeEditor = useCallback(() => {
    data?.closeNodeEditor?.();
  }, [data?.closeNodeEditor]);

  return { isEditing, openEditor, closeEditor };
}
